import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DataTableColumnDirective } from 'shared/modules/data-table/data-table-column.directive';
import { DataTableHeaderDirective } from 'shared/modules/data-table/data-table-header.directive';
import { DataTableRowDirective } from 'shared/modules/data-table/data-table-row.directive';
import { DataTableComponent } from 'shared/modules/data-table/data-table.component';

@NgModule({
  declarations: [
    DataTableComponent,
    DataTableHeaderDirective,
    DataTableRowDirective,
    DataTableColumnDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    DataTableComponent,
    DataTableHeaderDirective,
    DataTableRowDirective,
    DataTableColumnDirective,
  ],
})
export class DataTableModule {
}
